<!-- Logo mode always takes the same 16px slot (empty without a logo) so the IDs next to it line up. -->
<span *ngIf="mode === 'logo'; else chip" class="contractor-mark">
  <img
    *ngIf="contractor?.logoUrl && !logoFailed"
    class="contractor-mark__logo"
    [src]="contractor.logoUrl"
    [alt]="contractor.title"
    [matTooltip]="contractor.title"
    (error)="logoFailed = true"
  >
</span>

<ng-template #chip>
  <span *ngIf="contractor?.title" class="contractor-badge" [matTooltip]="mode === 'short' ? contractor.title : ''">
    <img
      *ngIf="contractor.logoUrl && !logoFailed"
      class="contractor-badge__logo"
      [src]="contractor.logoUrl"
      alt=""
      (error)="logoFailed = true"
    >
    <span class="contractor-badge__name">{{ name }}</span>
  </span>
</ng-template>
